import { Capacitor } from "@capacitor/core";
import jwtDecode from "jwt-decode";
import redirect from "lib/redirect";
import Router from "next/router";

export const signupAndLogin = async (email, password, resetCache) => {
  await Capacitor.Plugins.Auth.signup({ email, password });
  // Auth0.android automatically logs in, but Auth0.swift doesn't
  await Capacitor.Plugins.Auth.login({ email, password });
  // Clear cached empty /me result now we have a token
  resetCache();
  void Router.push("/account");
};

export const login = async (email, password) => {
  await Capacitor.Plugins.Auth.login({ email, password });

  void Router.push("/account");
};

// Never call this directly, redirect to /auth/sign-out instead
export const logout = async ({ returnTo = "/auth/sign-in" }) => {
  await Capacitor.Plugins.Auth.revoke();
  void Router.push(returnTo);
};

export const changePassword = (email) =>
  Capacitor.Plugins.Auth.changePassword({ email });

export const getStoredIdToken = async () =>
  (await Capacitor.Plugins.Auth.getTokens()).idToken;

export const getDecodedIdToken = async () => {
  const jwt = await getStoredIdToken();
  if (jwt) {
    return jwtDecode(jwt);
  }
};

export const wasLoggedIn = async () =>
  (await Capacitor.Plugins.Auth.hasValid()).hasValid;

export const reauthenticate = (ctx) => {
  // NOTE: The app uses refresh tokens so an access token can't expire
  // This method can be called though if a user's email address changes
  console.log("Invalid auth token, redirecting to sign out");
  redirect(ctx, "/auth/sign-out?returnTo=/auth/sign-in");
};
